// ** react imports
import React, { useEffect } from 'react';

// ** router imports
import { Link } from 'react-router-dom';

// ** redux imports
import { useDispatch, useSelector } from 'react-redux';
import {
  setEmailForForgotPassword,
  setIsForgotPassword,
  setIsOTPVerification,
} from '../redux/slices/users/index';

// ** view imports
import ForgotPasswordForm from '../views/users/ForgotPassword';
import VerifyOtpForm from '../views/users/VerifyOTP';

// ** images imports
import AuthImage from '../images/auth-image.jpg';
import ResetPasswordForm from '../views/users/ResetPassword';

const ForgotPassword = props => {
  // props
  const {} = props;

  // hooks
  const dispatch = useDispatch();
  const { isForgotPassword, isOTPVerification } = useSelector(
    state => state.users
  );
  useEffect(() => {
    dispatch(setEmailForForgotPassword(''));
    dispatch(setIsForgotPassword(false));
    dispatch(setIsOTPVerification(false));
  }, []);

  return (
    <main className="bg-white dark:bg-gray-900">
      <div className="relative md:flex">
        {/* Content */}
        {!isForgotPassword && <ForgotPasswordForm />}
        {isForgotPassword && !isOTPVerification && <VerifyOtpForm />}
        {isOTPVerification && <ResetPasswordForm />}

        {/* Image */}
        <div
          className="hidden md:block absolute top-0 bottom-0 right-0 md:w-1/2"
          aria-hidden="true"
        >
          <img
            className="object-cover object-center w-full h-full"
            src={AuthImage}
            width="760"
            height="1024"
            alt="Authentication"
          />
        </div>
      </div>
    </main>
  );
};

export default ForgotPassword;
